import Lhs from './lhs'
export default Lhs
